enum SubscriptionCancelType {
    UNKNOWN = 'unknown',
    CANCELLATION_REQUESTED = 'cancellation_requested',
    PAYMENT_DISPUTED = 'payment_disputed',
    PAYMENT_FAILED = 'payment_failed',
}

export default SubscriptionCancelType;
